import React from 'react';
import './About.css';

export default function About() {
  return (
    <section className="about-split" id="about">
      <div className="about-split__left">
        <div className="about-split__content">
          <span className="label">Who We Are</span>
          <h3 className="about-title">Our Story</h3>
          <p className="about-text">
            BeyonDigital was built on the belief that every brand deserves to be seen, heard, and remembered.
          </p>
          <p className="about-text" style={{ marginTop: '16px' }}>
            Starting from scratch, we understand the struggle of getting noticed in a competitive digital world. That's why we focus on creating strategies that not only attract attention but also drive real growth.
          </p>
          <p className="about-text" style={{ marginTop: '16px' }}>
            We combine creativity with data to ensure every decision is backed by insight, not guesswork.
          </p>
        </div>
      </div>

      <div className="about-split__right">
        <div className="about-split__top">
          <h4 className="about-title">
            <span className="label" style={{ marginBottom: '8px' }}>Vision</span>
          </h4>
          <p className="about-text">
            BeyonDigital envisions a future where all brands, regardless of size, have the capacity to differentiate themselves, grow and prosper in the digital age.
          </p>
        </div>

        <div className="about-split__bottom">
          <h4 className="about-title">
            <span className="label" style={{ marginBottom: '8px' }}>Mission</span>
          </h4>
          <p className="about-text">
            Built on resilience and ambition, our mission is to support brands through data-driven digital marketing solutions that help them grow, stand out and achieve meaningful success in an ever-changing digital landscape.
          </p>
        </div>
      </div>
    </section>
  );
}